import { BASE_URL } from '@avanta/shared/constants/common';
import { service } from '@avanta/shared/services/api';
import { type Gender } from '@avanta/shared/types/patients';
import { type AxiosResponse } from 'axios';
import { type ChatReportPayload } from 'types/chat-report';
import { type AnswerType } from 'types/sapa';

export type SapaReportAnswers = Record<string, AnswerType>;

const API_URL = `${BASE_URL}reports`;

export type SapaReportUserData = {
  email: string;
  company: string;
  nickname: string;
  gender: Gender;
  tlfnOrEmail?: string;
};

export type SapaReportPayload = {
  timestamp: string;
  userData: SapaReportUserData;
  answers: SapaReportAnswers;
};

export const ReportService = {
  sendChatReport: (body: ChatReportPayload): Promise<AxiosResponse<void>> =>
    service.post(`${API_URL}/patients/support`, body),

  sendSapaReport: (
    answers: SapaReportAnswers,
    userData: SapaReportUserData
  ): Promise<AxiosResponse<unknown>> => {
    const reportData: SapaReportPayload = {
      timestamp: new Date().toISOString(),
      userData,
      answers,
    };
    return service.post(`${API_URL}/sapa`, reportData);
  },
};
